import formatMoney from "accounting-js/lib/formatMoney.js";
export function formatNoCurrency(money) {
  return formatMoney(money, { symbol: "", format: "%s %v", precision: 0 });
}
export default function(money) {
  return formatMoney(money, { symbol: "UGX", format: "%v %s", precision: 0 });
}
